import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'app-admin-wrapper',
    templateUrl: './admin-wrapper.component.html',
    styleUrls: ['./admin-wrapper.component.scss'],
    standalone: false,
})
export class AdminWrapperComponent implements AfterViewInit {
    @ViewChild('content') content: ElementRef;
    @Input() element: ElementRef<unknown>;
    @Input() set showTooltip(show: boolean) {
        setTimeout(() => {
            this.tooltip = show ? `You don't have permissions to perform this action.` : '';
        });
    }

    tooltip: string;

    constructor(private renderer: Renderer2) {}

    ngAfterViewInit() {
        this.renderer.appendChild(this.content.nativeElement, this.element.nativeElement);
    }
}
